/**
 * Function for the checking whether the file is in the extension of
 * .pdf and images or not using magic number
 * @param {File} file - the file to be validated
 */
export const loadFile = (file, strictPDF = false) => {
  return new Promise((resolve, reject) => {
    // Create a new instance of FileReader
    const filereader = new FileReader()

    // Define the callback function for when the file is loaded
    filereader.onloadend = (e) => {
      // Extract the first 4 bytes of the file as an Uint8Array
      const arr = new Uint8Array(e.target.result).subarray(0, 4)
      let header = ""

      // Iterate over the bytes and convert them to hexadecimal representation
      for (let i = 0; i < arr.length; i++) {
        header += arr[i].toString(16)
      }

      if (header == "25504446") {
        const fileObj = { type: "pdf", file: file }
        resolve(fileObj)
      } else if (header == "504b34" && !strictPDF && file.type != "application/x-zip-compressed") {
        const fileObj = { type: "docx", file: file }
        resolve(fileObj)
      } else {
        reject("Invalid Format")
      }
    }

    // Read the first 4 bytes of the file as an ArrayBuffer
    filereader.readAsArrayBuffer(file.slice(0, 4))
  })
}

export const parsePdf = (file) => {
  return new Promise((resolve, reject) => {
    // Create a new instance of FileReader
    const filereader = new FileReader()

    // Define the callback function for when the file is loaded
    filereader.onloadend = (e) => {
      // Extract the first 4 bytes of the file as an Uint8Array
      const pdfBytes = new Uint8Array(e.target.result)

      const decoder = new TextDecoder("utf-8")
      const pdfText = decoder.decode(pdfBytes)

      if (pdfText.includes("/Filter /Standard")) reject("Password Protected Files not allowed")

      let byteRangeRegex = /\/ByteRange\s*\[\s*(\d+)\s+(\d+)\s+(\d+)\s+(\d+)\s*\]/g

      let matches = [...pdfText.matchAll(byteRangeRegex)]

      if (matches.length != 0) resolve(true)
      else resolve(false)
    }

    // Read the first 4 bytes of the file as an ArrayBuffer
    filereader.readAsArrayBuffer(file)
  })
}
